import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Paper from '@material-ui/core/Paper'
import moment from 'moment'
import { withStyles } from '@material-ui/core/styles'
import HeaderHistoryComponent from './HeaderHistoryComponent'
import SingleHistoryComponent from './SingleHistoryComponent'
import FooterHistoryComponent from './FooterHistoryComponent'
import TimeChipComponent from './TimeChipComponent'
import Grid from '@material-ui/core/Grid'
const styles = theme => ({
  container: {
    position: 'relative',
    overflow: 'hidden'
  }
})
class HistoryComponent extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    history: PropTypes.array,
    currentDates: PropTypes.object,
    showModal: PropTypes.func.isRequired,
    theme: PropTypes.object.isRequired
  }
  static defaultProps = {
    history: []
  }
  renderEmptyHistory() {
    return <Paper />
  }
  renderHistory() {
    const { history } = this.props
    const now = moment()
    let topDate = moment(now)
    topDate.set({ m: 0, s: 0, ms: 0 })
    let bottomDate = moment(topDate)
    topDate.add(1, 'h')

    // now.set({m : 0, s : 0, ms : 0})
    // now.add(1, 'h')
    let isTopChipAdded = true
    let chipIndex = 0
    let counter = 0
    let content = []
    for (const h of history) {
      const date = moment(h.transaction.updatedAt)
      if (now.isBetween(bottomDate, topDate)) {
        topDate = moment(now)
        topDate.set({ m: 0, s: 0, ms: 0 })
        topDate.add(1, 'h')
        isTopChipAdded = true
      }
      if (date.isBetween(bottomDate, topDate) && isTopChipAdded) {
        content.push(
          <SingleHistoryComponent
            style={counter === 0 ? { marginTop: '30px' } : {}}
            key={h.key}
            history={h}
            showModal={this.props.showModal}
          />
        )
      } else if (date.isBetween(bottomDate, topDate) && !isTopChipAdded) {
        content.push(
          <TimeChipComponent key={chipIndex} date={topDate.format('HH:mm')} />
        )
        content.push(
          <SingleHistoryComponent
            key={h.key}
            history={h}
            showModal={this.props.showModal}
          />
        )
        isTopChipAdded = true
        chipIndex++
      } else if (!date.isBetween(bottomDate, topDate)) {
        bottomDate = moment(h.transaction.updatedAt)
        bottomDate.set({ m: 0, s: 0, ms: 0 })
        topDate = moment(h.transaction.updatedAt)
        topDate.set({ m: 0, s: 0, ms: 0 })
        topDate.add(1, 'h')
        if (counter !== 0) {
          content.push(
            <TimeChipComponent key={chipIndex} date={topDate.format('HH:mm')} />
          )
        }
        content.push(
          <SingleHistoryComponent
            style={counter === 0 ? { marginTop: '30px' } : {}}
            key={h.key}
            history={h}
            showModal={this.props.showModal}
          />
        )
        isTopChipAdded = true
        chipIndex++
      } else {
        topDate = moment(date)
        topDate.set({ minute: 0, second: 0, millisecond: 0 })
        topDate.add(1, 'h')
        content.push(
          <TimeChipComponent key={chipIndex} date={topDate.format('HH:mm')} />
        )
        content.push(
          <SingleHistoryComponent
            key={h.key}
            history={h}
            showModal={this.props.showModal}
          />
        )
        isTopChipAdded = true
        chipIndex++
      }
      counter++
    }
    return content
  }
  getStyleTagStyles = theme => {
    return (
      `.contentHistory {
      position : relative;
      padding-left : 16px;
      padding-right : 16px;
      width : 100%;
      height : auto;
    }
      .contentHistory:before {
        content:"";
        position: absolute;
        z-index: -1;
        top: 0;
        height:100%;
        left: 50%;
        margin-left: -5px;
        width: 10px;
        background: ` +
      theme.palette.primary.main +
      ` ;
      }
    }
    .headerTimeline {
      position : relative;
      width : 100%;
      height : auto;
    }
    .headerTimeline:before {
        content:"";
        position: absolute;
        z-index: -1;
        top: 31px;
        height:100%;
        left: 50%;
        margin-left: -5px;
        width: 10px;
        background: ` +
      theme.palette.primary.main +
      `;
      }
      .fullMainHistory {
        width:100%;
        position: absolute;
        top:30px;
        left:0;
        bottom:0;
        padding: 2px;
        overflow: scroll;
        flex-flow: column;
        justify-content: center;
        vertical-align: top;
      }
    }`
    )
  }
  render() {
    const { theme, classes, history, currentDates } = this.props
    const { startDate } = currentDates
    let content = null
    if (history.length === 0) {
      content = this.renderEmptyHistory()
    } else {
      content = this.renderHistory()
    }
    return (
      <Grid
        className={classes.container}
        item
        container
        direction="row"
        alignItems="stretch"
        justify="flex-start">
        <style
          type="text/css"
          dangerouslySetInnerHTML={{ __html: this.getStyleTagStyles(theme) }}
        />
        <HeaderHistoryComponent />
        <div className="fullMainHistory">
          <div className="contentHistory">
            {content}
            <FooterHistoryComponent
              startDate={startDate || moment().format()}
            />
          </div>
        </div>
      </Grid>
    )
  }
}

export default withStyles(styles, { withTheme: true })(HistoryComponent)



// WEBPACK FOOTER //
// ./src/routes/History/components/HistoryComponent.js